var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"dashboard-view"}},[_c('core-toolbar'),_c('core-drawer'),_c('v-content',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }